import { render, staticRenderFns } from "./BusinessAccountAdmin.vue?vue&type=template&id=ca15030c"
import script from "./BusinessAccountAdmin.vue?vue&type=script&lang=js"
export * from "./BusinessAccountAdmin.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports